export default __webpack_public_path__ + "static/media/unknown.89ec3e26.svg";